module.exports = __webpack_public_path__ + "fonts/CabinetGrotesk-Black.f8dd7ae2.woff";